<template lang="pug">
.success-dialog-backdrop(v-if="modelValue")
  .success-dialog(@click.stop)
    button.close-btn(@click="handleClose")
      svg(viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
        path(d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")

    .circle-content(v-if="!showSignupForm")
      h1.circle-title
        span.title-text JOIN THE 
        span.title-highlight CIRCLE
        
      .title-underline
        svg(width="280" height="16" viewBox="0 0 280 16" fill="none" xmlns="http://www.w3.org/2000/svg")
          path(d="M2 8C50 4 80 12 140 10C200 8 250 4 278 8" stroke="#7C5CCC" stroke-width="4" stroke-linecap="round")

      p.circle-subtitle A shared space to support causes,
        br
        | unlock rewards, and direct impact together.

      .features-list
        .feature-item
          .feature-icon
            svg.main-icon(width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg")
              circle(cx="32" cy="32" r="32" fill="#7C5CCC")
              rect(x="16" y="28" width="32" height="24" rx="2" fill="white")
              path(d="M32 16L24 28H40L32 16Z" fill="white")
              rect(x="28" y="18" width="8" height="10" fill="#7C5CCC")
              path(d="M20 34H44" stroke="#7C5CCC" stroke-width="2.5" stroke-linecap="round")
              circle(cx="24" cy="42" r="3" fill="#7C5CCC")
              circle(cx="32" cy="42" r="3" fill="#7C5CCC")
              circle(cx="40" cy="42" r="3" fill="#7C5CCC")
          .feature-text
            h3.feature-title Exclusive Rewards
            p.feature-description Access member-only perks, drops,
              br
              | experiences, and giveaways.

        .feature-item
          .feature-icon
            svg.main-icon(width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg")
              circle(cx="32" cy="32" r="32" fill="#7C5CCC")
              rect(x="18" y="14" width="28" height="36" rx="2" fill="white")
              rect(x="18" y="46" width="28" height="4" rx="1" fill="white")
              path(d="M26 26L30 30L38 22" stroke="#7C5CCC" stroke-width="3" stroke-linecap="round" stroke-linejoin="round")
              line(x1="24" y1="36" x2="40" y2="36" stroke="#7C5CCC" stroke-width="2.5" stroke-linecap="round")
              line(x1="24" y1="42" x2="34" y2="42" stroke="#7C5CCC" stroke-width="2.5" stroke-linecap="round")
          .feature-text
            h3.feature-title Vote on Impact
            p.feature-description Help decide which nonprofits,
              br
              | projects, and community moments
              br
              | get supported.

        .feature-item
          .feature-icon
            svg.main-icon(width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg")
              circle(cx="32" cy="32" r="32" fill="#7C5CCC")
              rect(x="14" y="22" width="36" height="26" rx="3" fill="white")
              rect(x="14" y="28" width="36" height="4" fill="#7C5CCC")
              circle(cx="42" cy="38" r="4" fill="#7C5CCC")
              path(d="M20 38L24 42L28 38" stroke="#14B8A6" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none")
              path(d="M23 40C23 38 24 36 26 36C28 36 29 38 29 40" stroke="#14B8A6" stroke-width="2" stroke-linecap="round" fill="none")
          .feature-text
            h3.feature-title Shared Giving Wallet
            p.feature-description Brands and sponsors can add
              br
              | dollars to the circle to boost
              br
              | collective impact and participation.

      button.join-btn(@click="showSignupForm = true")
        span JOIN UP
        svg(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
          path(d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round")

    .signup-form-content(v-else)
      h2.form-title Create Your Account
      p.form-subtitle Track your donations and make an impact

      .form-field
        label.field-label First Name
        input.form-input(
          v-model="signupForm.firstName"
          type="text"
          placeholder="Enter your first name"
          :class="{ 'has-error': errors.firstName }"
        )
        .error-text(v-if="errors.firstName") {{ errors.firstName }}

      .form-field
        label.field-label Last Name
        input.form-input(
          v-model="signupForm.lastName"
          type="text"
          placeholder="Enter your last name"
          :class="{ 'has-error': errors.lastName }"
        )
        .error-text(v-if="errors.lastName") {{ errors.lastName }}

      .form-field
        label.field-label Email
        input.form-input(
          v-model="signupForm.email"
          type="email"
          placeholder="Enter your email"
          :class="{ 'has-error': errors.email }"
        )
        .error-text(v-if="errors.email") {{ errors.email }}

      .form-field
        label.field-label Phone Number
        input.form-input(
          v-model="signupForm.phone"
          type="tel"
          placeholder="(123) 456-7890"
          :class="{ 'has-error': errors.phone }"
        )
        .error-text(v-if="errors.phone") {{ errors.phone }}

      .form-field
        label.field-label Password
        input.form-input(
          v-model="signupForm.password"
          type="password"
          placeholder="Create a password"
          :class="{ 'has-error': errors.password }"
        )
        .error-text(v-if="errors.password") {{ errors.password }}

      .form-actions
        button.submit-btn(
          :disabled="isSubmitting"
          @click="handleSignup"
        )
          span(v-if="!isSubmitting") Create Account
          span.loading-text(v-else)
            span.spinner
            span Creating...
        button.back-btn(@click="showSignupForm = false") Back

canvas.confetti-canvas(ref="confettiCanvas")
</template>

<script lang="ts">
import {
  defineComponent, ref, watch, onMounted, onUnmounted, nextTick,
} from 'vue';
import { ElMessage } from 'element-plus';
import { makeRequest } from '@/graphs/index';
import { signUp } from '@/graphs/invite';
import { useConfetti } from '@/composables/useConfetti';

export default defineComponent({
  name: 'DialogDonationSuccess',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    causeName: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { initConfetti, stopConfetti, triggerConfettiBurst } = useConfetti();
    const confettiCanvas = ref<HTMLCanvasElement | null>(null);
    const showSignupForm = ref(false);
    const isSubmitting = ref(false);

    const signupForm = ref({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      password: '',
    });

    const errors = ref({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      password: '',
    });

    const startConfetti = async () => {
      await nextTick();
      if (confettiCanvas.value) {
        console.log('=== STARTING CONFETTI ===');
        initConfetti(confettiCanvas.value);
        triggerConfettiBurst(confettiCanvas.value);
      }
    };

    const validateForm = () => {
      errors.value = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
      };

      let isValid = true;

      if (!signupForm.value.firstName.trim()) {
        errors.value.firstName = 'First name is required';
        isValid = false;
      }

      if (!signupForm.value.lastName.trim()) {
        errors.value.lastName = 'Last name is required';
        isValid = false;
      }

      if (!signupForm.value.email.trim()) {
        errors.value.email = 'Email is required';
        isValid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(signupForm.value.email)) {
        errors.value.email = 'Please enter a valid email';
        isValid = false;
      }

      if (!signupForm.value.phone.trim()) {
        errors.value.phone = 'Phone number is required';
        isValid = false;
      } else if (!/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(signupForm.value.phone.replace(/\s/g, ''))) {
        errors.value.phone = 'Please enter a valid phone number';
        isValid = false;
      }

      if (!signupForm.value.password) {
        errors.value.password = 'Password is required';
        isValid = false;
      } else if (signupForm.value.password.length < 6) {
        errors.value.password = 'Password must be at least 6 characters';
        isValid = false;
      }

      return isValid;
    };

    const handleSignup = async () => {
      if (!validateForm()) {
        return;
      }

      isSubmitting.value = true;
      try {
        console.log('=== CREATING ACCOUNT ===');
        console.log('Email:', signupForm.value.email);

        const input = {
          firstname: signupForm.value.firstName,
          lastname: signupForm.value.lastName,
          email: signupForm.value.email.toLowerCase(),
          phone: signupForm.value.phone,
          password: signupForm.value.password,
          age: 18,
          isMarketingAgreed: false,
        };

        const response = await makeRequest(
          'mutation',
          signUp,
          { input },
          null,
        );

        if (response?.errors) {
          throw new Error(response.errors[0]?.message || 'Failed to create account');
        }

        console.log('=== ACCOUNT CREATED ===');
        console.log('Response:', response);

        ElMessage.success('Account created successfully! You can now sign in anytime.');
        handleClose();
      } catch (error: any) {
        console.error('Signup error:', error);
        ElMessage.error(error.message || 'Failed to create account. Please try again.');
      } finally {
        isSubmitting.value = false;
      }
    };

    const handleClose = () => {
      stopConfetti();
      showSignupForm.value = false;
      signupForm.value = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
      };
      errors.value = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
      };
      emit('update:modelValue', false);
    };

    watch(() => props.modelValue, (newValue) => {
      console.log('=== SUCCESS DIALOG modelValue CHANGED ===');
      console.log('New modelValue:', newValue);
      if (newValue) {
        showSignupForm.value = false;
        startConfetti();
      } else {
        stopConfetti();
      }
    });

    onMounted(() => {
      if (props.modelValue) {
        startConfetti();
      }
    });

    onUnmounted(() => {
      stopConfetti();
    });

    return {
      confettiCanvas,
      showSignupForm,
      isSubmitting,
      signupForm,
      errors,
      handleSignup,
      handleClose,
    };
  },
});
</script>

<style lang="scss" scoped>
.success-dialog-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.5);
}

.success-dialog {
  background: #F5F3EE;
  border-radius: 32px;
  padding: 32px 28px;
  max-width: 480px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideUp 0.4s ease;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  pointer-events: auto;

  @media (min-width: 768px) {
    padding: 40px 36px;
    max-width: 520px;
  }
}

.close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 40px;
  height: 40px;
  border-radius: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
  z-index: 1;
  padding: 0;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 28px;
    height: 28px;
    color: #1a1a1a;
  }
}

.circle-content {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.circle-title {
  font-size: 2rem;
  font-weight: 900;
  line-height: 1.1;
  margin: 0 0 6px 0;
  letter-spacing: -0.02em;

  @media (min-width: 768px) {
    font-size: 2.25rem;
  }

  .title-text {
    color: #1a1a1a;
  }

  .title-highlight {
    color: #7C5CCC;
    display: inline-block;
    position: relative;
  }
}

.title-underline {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;

  svg {
    width: 200px;
    height: 12px;
  }
}

.circle-subtitle {
  font-size: 0.9375rem;
  color: #1a1a1a;
  line-height: 1.4;
  margin: 0 0 28px 0;
  max-width: 420px;

  @media (min-width: 768px) {
    font-size: 1rem;
  }
}

.features-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 28px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  text-align: left;
  background: rgba(255, 255, 255, 0.4);
  padding: 14px;
  border-radius: 16px;

  @media (min-width: 768px) {
    gap: 18px;
    padding: 16px;
  }
}

.feature-icon {
  flex-shrink: 0;

  .main-icon {
    width: 72px;
    height: 72px;
    display: block;

    @media (min-width: 768px) {
      width: 80px;
      height: 80px;
    }
  }
}

.feature-text {
  flex: 1;
  padding-top: 4px;
}

.feature-title {
  font-size: 1.0625rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 6px 0;
  line-height: 1.2;

  @media (min-width: 768px) {
    font-size: 1.125rem;
  }
}

.feature-description {
  font-size: 0.875rem;
  color: #4a4a4a;
  line-height: 1.4;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 0.9375rem;
  }
}

.join-btn {
  width: 100%;
  max-width: 400px;
  padding: 14px 28px;
  background: #7C5CCC;
  color: white;
  border: none;
  border-radius: 14px;
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 4px 12px rgba(124, 92, 204, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(124, 92, 204, 0.4);
    background: #8B6DD9;
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 24px;
    height: 24px;
  }
}

.signup-form-content {
  text-align: left;
}

.form-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #0f766e;
  margin: 0 0 8px 0;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 2rem;
  }
}

.form-subtitle {
  font-size: 0.9375rem;
  color: #666;
  margin: 0 0 24px 0;
  text-align: center;
}

.form-field {
  margin-bottom: 16px;
}

.field-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 1rem;
  color: #1a1a1a;
  transition: all 0.2s;
  background-color: #ffffff;

  &:focus {
    outline: none;
    border-color: #14b8a6;
    box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }

  &.has-error {
    border-color: #ef4444;
  }
}

.error-text {
  margin-top: 4px;
  font-size: 0.8125rem;
  color: #ef4444;
}

.form-actions {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.submit-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(13, 148, 136, 0.3);
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }
}

.back-btn {
  width: 100%;
  padding: 12px;
  background: transparent;
  color: #64748b;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 0.9375rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #f1f5f9;
    border-color: #cbd5e1;
    color: #475569;
  }
}

.loading-text {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

.confetti-canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
